<div >
    <div class="server-down-section  d-flex align-items-center justify-content-center flex-column px-4">
        <h1 class="text-center header mt-4 pb-4" >We are down!</h1>
        <img src="assets/images/server-maintenance.svg" class="w-50 px-2" alt="server-down"/>
        <h5 class="text-center  mt-3" >We apologize for the inconvenience</h5>
        <h5 class="text-center mt-3 mb-5 mx-auto" >Our website is currently down for maintainance, but we're working hard to get things back up and running as soon as possible. Thank you for your patience and understanding.</h5>
    </div>
</div>
1